import {Outlet, createFileRoute} from "@tanstack/react-router";

import {routeMessages} from "../../../../../messages/routes.messages";

export const Route = createFileRoute("/_app/sales/offers/templates")({
  component: () => <Outlet />,
  staticData: {
    meta: {
      labelDescriptor: routeMessages.offerTemplates,
      moduleDescriptor: routeMessages.sales,
    },
  },
});
